<main class="main">
  <mat-dialog-content>
    <p>{{ 'emptyConfigurationError' | i18next }}</p>
  </mat-dialog-content>
  <button
    class="main--btnContainer__btn btn cancel"
    type="button"
    mat-dialog-close
  >
    {{ 'btnClose' | i18next | uppercase }}
  </button>
</main>
